import React, { createContext, useState } from 'react';
import DocumentDrawer from '../DocumentDrawer/DocumentDrawer';

export const VisiblePreviewContext = createContext();
export const ChangeVisiblePreviewContext = createContext();

const DocForm = () => {
  const [visiblePreview, setVisiblePreview] = useState(null);

  return (
    <VisiblePreviewContext.Provider value={visiblePreview}>
      <ChangeVisiblePreviewContext.Provider value={setVisiblePreview}>
        <DocumentDrawer />
      </ChangeVisiblePreviewContext.Provider>
    </VisiblePreviewContext.Provider>
  );
};

export default DocForm;
